import { jsx as _jsx } from "react/jsx-runtime";
import IMask from 'imask';
import { forwardRef, useCallback, useState } from 'react';
import { BKJTextInput } from '../BKJTextInput/index.js';
export const BKJPhoneNumberInput = forwardRef((props, ref) => {
    const { onChange, value = '', name, maxLength, ...rest } = props;
    let mask = '';
    if (maxLength) {
        switch (true) {
            case maxLength >= 12:
                mask = '(000) 000-0000-00';
                break;
            case maxLength === 11:
                mask = '(000) 000-0000-0';
                break;
            default:
                mask = '(000) 000-0000';
        }
    }
    const formatPhoneNumber = IMask.createMask({
        mask: mask,
    });
    const [displayValue, setDisplayValue] = useState(formatPhoneNumber.resolve(value));
    const handleChange = useCallback((e) => {
        if (onChange) {
            formatPhoneNumber.resolve(e.target.value);
            setDisplayValue(formatPhoneNumber.value);
            e.target.value = formatPhoneNumber.unmaskedValue;
            onChange(e);
        }
    }, [formatPhoneNumber, onChange]);
    return (_jsx(BKJTextInput, { ...rest, name: name, ref: ref, value: displayValue, onChange: handleChange }));
});
//# sourceMappingURL=BKJPhoneNumberInput.js.map